import { Link } from 'react-router-dom'
import './style.css'

export function Footer() {
  const menuItems = [
    { label: 'Início', path: '/' },
    { label: 'Institucional', path: '/institucional' },
    { label: 'Contato', path: '/contato' }
  ]

  const renderMenuItems = () => {
    return menuItems.map((item) => (
      <li key={item.path} className="menu-item">
        <Link to={item.path}>{item.label}</Link>
      </li>
    ))
  }

  return (
    <footer className="footer">
      {/* Top section */}
      <div className="footer-top">
        <div className="footer-column brand">
          <h2>VidaPlus</h2>
          <p>
            In consequat arcu nec mi convallis condimentum. Proin consequat tortor id tempus
            pellentesque. Nam pharetra, neque ut sodales facilisis, leo.
          </p>
        </div>

        <div className="footer-column">
          <h4>Unidade Rio Grande do Sul</h4>
          <p>
            Avenida Brasil, 126 - Barra Funda
            <br />
            Pelotas - RS, CEP 56485-857
          </p>
          <p>(20) 8746-9038</p>
        </div>

        <div className="footer-column">
          <h4>Unidade São Paulo</h4>
          <p>
            Alameda Santos, 808 - Centro
            <br />
            São Paulo - SP, CEP 78435-435
          </p>
          <p>(10) 7725-5565</p>
        </div>

        <div className="footer-column">
          <h4>Unidade Bahia</h4>
          <p>
            Travessa da Paz, 562 - Copacabana
            <br />
            Itabuna - BA, CEP 95694-824
          </p>
          <p>(99) 6766-3297</p>
        </div>
      </div>

      <div className="footer-bottom">
        <span className="footer-logo">VidaPlus</span>

        <nav className="footer-nav">
          <ul className="menu-list">{renderMenuItems()}</ul>
        </nav>
      </div>
    </footer>
  )
}
